import * as React from 'react';
import { useStore } from 'zustand';
import { CriteriaStoreContext } from '../context';

/**
 * Resets store values
 * @returns function | null
 */
export const useCriteriaStoreReset = () => {
    const { store } = React.useContext(CriteriaStoreContext);
    if (!store) throw new Error('Missing CriteriaStoreContext.Provider in the tree');
    const reset = useStore(store, (s) => s.reset);

    return reset;
};
